import type { PartialMessages } from "../messages";

export const ru: PartialMessages = {
  "status.syncing": "Синхронизировано",
  "status.connecting": "Подключение",
  "status.full": "Заполнено",
  "status.closed": "Нет связи",
  "toast.connecting": "Подключение…",
  "toast.reconnecting": "Связь потеряна. Переподключение…",
  "toast.retrying": "Скоро повторим попытку.",
  "toast.busy": "Сейчас высокая нагрузка",
  "notice.mapChanged": "{name} сменил карту",

  "hint.place": "Клик — поставить, перетащить — задать направление (Esc — отмена)",

  "kind.objective": "Цель",
  "kind.rally": "Сбор",
  "kind.enemy": "Враг",
  "kind.loot": "Лут",
  "kind.extract": "Выход",
  "kind.danger": "Опасность",
  "kind.self": "Я",
  "kind.ping": "Сюда!",
  "hint.objective": "Куда идём",
  "hint.rally": "Место сбора",
  "hint.enemy": "Направьте туда, откуда его видели",
  "hint.loot": "Редкие контейнеры, трупы",
  "hint.extract": "Планируемый выход",
  "hint.danger": "Мины, снайперы, открытое место",
  "hint.self": "Ваша позиция. Новая метка убирает старую",
  "hint.ping": "Временная метка, исчезает через 25 секунд",

  "tool.clearMine": "Убрать свои",
  "tool.clearMineHint": "Удаляет все метки, которые вы поставили",

  "sidebar.map": "Карта (для всех)",
  "sidebar.styleSvg": "Рисованная",
  "sidebar.styleTile": "Спутник",
  "sidebar.floors": "Этаж (меняется только у вас)",
  "sidebar.groundFloor": "Земля",
  "sidebar.floorNote": "Метки на других этажах показаны бледнее.",
  "sidebar.members": "Участников: {count}",
  "sidebar.you": "вы",
  "sidebar.guest": "гость",
  "sidebar.clearAll": "Убрать все метки",
  "sidebar.openWindow": "Открыть в окне (для себя)",
  "sidebar.invite": "Пригласить",
  "sidebar.help": "Как пользоваться",
  "sidebar.feedback": "Написать автору",
  "sidebar.mapData": "Данные карты",
  "sidebar.license": "Лицензия",
  "sidebar.licenseNote": "только некоммерческое использование",
  "sidebar.room": "Комната",

  "pin.facing": "Направление",
  "pin.floor": "Этаж",
  "pin.map": "Карта",
  "pin.noFacing": "Без направления",
  "pin.facingValue": "{compass} ({degrees}°)",
  "pin.notePlaceholder": "Заметка (например: окно на 3-м этаже)",
  "pin.removeMine": "Удалить эту метку",
  "pin.removeOther": "Удалить чужую метку",
  "pin.close": "Закрыть",
  "compass.n": "С", "compass.ne": "СВ", "compass.e": "В", "compass.se": "ЮВ",
  "compass.s": "Ю", "compass.sw": "ЮЗ", "compass.w": "З", "compass.nw": "СЗ",

  "handoff.title": "Открыть в окне",
  "handoff.lede":
    "Ссылка для вас самих. Откроет ту же комнату в браузере, чтобы в Discord осталась трансляция, а карта была на другом экране.",
  "handoff.open": "Открыть в браузере этого компьютера",
  "handoff.or": "На другом устройстве",
  "handoff.codeHint": "На нём откройте {host}/j/ и введите код выше.",
  "handoff.copy": "Скопировать ссылку",
  "handoff.copied": "Скопировано",
  "handoff.copyFailed": "Выделено выше — нажмите Ctrl+C",
  "handoff.expiry": "Ссылка одноразовая. Истекает через {time}.",
  "handoff.warn":
    "Передавать другим бесполезно: при открытии она расходуется. Для этого есть «Пригласить».",
  "handoff.creating": "Создаём ссылку…",
  "handoff.failed": "Не удалось создать ссылку",

  "invite.title": "Пригласить",
  "invite.lede":
    "Позовите того, кого нет в голосовом канале. Он введёт имя и сможет ставить метки.",
  "invite.copy": "Скопировать ссылку",
  "invite.warn": "Присоединиться сможет любой, у кого есть ссылка. Не публикуйте её.",
  "invite.budget": "Ещё {left} чел., истекает через {time} (использовано {used}/{max}).",
  "invite.revoke": "Отозвать ссылку сейчас",
  "invite.revoked": "Ссылка отозвана.",
  "invite.creating": "Создаём ссылку…",
  "invite.failed": "Не удалось создать ссылку",
  "invite.revokeFailed": "Не удалось отозвать",

  "join.title": "Присоединиться к карте",
  "join.lede":
    "Вас пригласили на карту рейда. Выберите отображаемое имя — оно будет стоять на ваших метках.",
  "join.name": "Имя",
  "join.go": "Войти",
  "join.joining": "Входим…",
  "join.failed": "Не удалось войти",

  "feedback.title": "Написать автору",
  "feedback.request": "Пожелание",
  "feedback.bug": "Ошибка",
  "feedback.other": "Другое",
  "feedback.requestHint": "Было бы здорово…",
  "feedback.bugHint": "Что-то не так",
  "feedback.otherHint": "Что угодно",
  "feedback.placeholder":
    "например: хочу рисовать линии, а не только стрелки / на Streets не переключаются этажи",
  "feedback.note": "Вместе с текстом уйдут ваше имя в Discord и ID, чтобы можно было ответить.",
  "feedback.send": "Отправить",
  "feedback.sending": "Отправляем…",
  "feedback.sent": "Отправлено. Спасибо!",
  "feedback.failed": "Не удалось отправить",

  "time.minutes": "{n} мин",
  "time.hoursMinutes": "{h} ч {m} мин",

  "error.roomFull": "Комната заполнена",
  "error.tooManyWindows": "Слишком много окон этой комнаты. Закройте одно.",
  "error.serverFull": "Сервер перегружен",
  "error.session": "Сессия недействительна. Откройте заново.",
  "error.handoffSpent":
    "Ссылка не работает. Она одноразовая и только для того, кто её создал. Чтобы позвать кого-то, создайте на карте ссылку-приглашение.",
  "error.inviteSpent": "Приглашение больше не действует. Попросите новую ссылку.",
  "error.inviteNotOwner": "Отозвать ссылку может только тот, кто её создал",
  "error.noRoom": "Комната не указана",
  "error.needName": "Введите имя",
  "error.tooShort": "Напишите чуть подробнее",
  "error.tooLong": "Слишком длинно",
  "error.badKind": "Неверная категория",
  "error.rateLimited": "Слишком часто. Подождите около 10 минут.",
  "error.busy": "Сейчас загружено. Попробуйте чуть позже.",
  "error.sendFailed": "Не удалось отправить. Попробуйте позже.",
  "error.feedbackClosed": "Приём обращений сейчас закрыт",
  "error.sessionGone": "Исходная сессия завершена. Откройте активность заново.",

  "landing.tagline1": "Общая карта Таркова",
  "landing.tagline2": "для всех в голосовом канале Discord — показывайте прямо на ней.",
  "landing.install": "Добавить в Discord",
  "landing.installNote": "Бесплатно. Запуск по иконке ракеты в голосовом канале.",
  "landing.body":
    "У всех в канале одна и та же карта. Клик ставит метку, а если при этом потянуть — появится стрелка направления. Так видно не только где, но и куда.",
  "landing.point1": "Достаточно быть в одном канале. Никаких кодов",
  "landing.point2": "Все 13 карт. Рисованные и спутниковые, плюс этажи",
  "landing.point3": "Метки остаются на месте, к ним можно вернуться",
  "landing.point4": "Кто не в канале — заходит по ссылке-приглашению",
  "landing.footNote":
    "Игры это не касается. Ни файлов, ни памяти, ничего поверх игры. Каждая метка ставится руками.",
  "landing.footCredit":
    "Любительский проект, работает бесплатно. Данные карт — {tarkovdev} (CC BY-NC-SA 4.0). Escape from Tarkov — продукт Battlestate Games Limited; это неофициальный фанатский проект, никак с ними не связанный.",
  "landing.updates": "Обновления",
  "landing.allUpdates": "Все обновления",

  "boot.connecting": "Подключение к Discord…",
  "boot.failedTitle": "Не удалось запустить",
};
